import { render, staticRenderFns } from "./paymentMoney.vue?vue&type=template&id=5a1a4702&scoped=true"
import script from "./paymentMoney.vue?vue&type=script&lang=js"
export * from "./paymentMoney.vue?vue&type=script&lang=js"
import style0 from "./paymentMoney.vue?vue&type=style&index=0&id=5a1a4702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a4702",
  null
  
)

export default component.exports